import { RootState } from '../../store';

export const getCustomersSelector = (state: RootState) => state?.ticketReducer?.customers;
